import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "~/components/ui/dialog";

interface StationDeleteDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  stationName: string;
  colorValue: { color: string; stroke: string };
  onDelete: () => void;
  deletePending: boolean;
}

export function StationDeleteDialog({
  isOpen,
  onOpenChange,
  stationName,
  colorValue,
  onDelete,
  deletePending,
}: StationDeleteDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={isOpen}>
      <DialogContent className="sm:max-w-md" noScrollPrevention>
        <DialogTitle className="sr-only">Delete Station</DialogTitle>
        <DialogDescription className="sr-only">
          Confirm deletion of this station
        </DialogDescription>
        <div className="flex flex-col items-center gap-5">
          <h2 className="h4">Delete Station?</h2>
          <p className="text-muted-foreground text-center">
            Are you sure you want to delete "{stationName}"? This cannot be
            undone.
          </p>
          <div
            className="flex h-12 w-40 items-center justify-center rounded-xl"
            style={{
              background: colorValue.color,
              border: `1px solid ${colorValue.stroke}`,
            }}
          >
            {stationName}
          </div>
          <div className="flex gap-3">
            <Button onClick={() => onOpenChange(false)} variant="outline">
              Cancel
            </Button>
            <Button
              disabled={deletePending}
              onClick={onDelete}
              variant="destructive"
            >
              Delete
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
